//Formik
import FormikTextInput from "../../../../../helpers/formikInputs/FormikTextInput"
import FormikTextAreaInput from "../../../../../helpers/formikInputs/FormikTextAreaInput"
import elementTypes from "../Elements/elementTypes"
import { useField } from "formik"

export default function QuestionText({
  formikQuestionName,
  questionType,
  disabled,
}) {
  if (elementTypes.descriptionElementId === questionType) {
    return (
      <FormikTextAreaInput
        name={`${formikQuestionName}.text`}
        label={"Label"}
        placeholderText={"Please specify a label for this question"}
        required={true}
        disabled={disabled}
        rows={4}
      />
    )
  } else {
    return (
      <FormikTextInput
        name={`${formikQuestionName}.text`}
        label={"Label"}
        placeholderText={"Please specify a label for this question"}
        required={true}
        disabled={disabled}
      />
    )
  }
}
